import React, { useEffect, useRef, useState } from 'react'
import abbreviate from 'abbreviate-name'
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import ReactToPrint from 'react-to-print'
import { Print } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { useAbility } from '../Usuarios'
import { BadgeStatus } from '../Solicitacoes/components'
import { canPrintProtocolo } from '../Solicitacoes/utils'
import SolicitacaoPrint from '../Solicitacoes/SolicitacaoPrintProtocolo'
import consultaHistoricoRepository from './consultaHistoricoRepository'

// Mesmo estilo de cartão usado nos demais blocos desta tela (ver `informacao`
// em ConsultaHistoricoCard.js), pra manter a moldura igual à do bloco antigo.
const useStyles = makeStyles(() => ({
  informacao: {
    padding: 32,
    paddingBottom: 0
  },
  // Evita quebra de linha nos cabeçalhos/células — a tabela rola na
  // horizontal (via TableContainer) em vez de espremer o conteúdo.
  table: {
    '& th, & td': {
      whiteSpace: 'nowrap'
    }
  }
}))

const ComponentImpressao = ({ props }) => {
  const [canPrint, setCanPrint] = useState(false)
  const printRef = useRef()

  const status = props?.status
  const dataTermino = props?.dataTermino
  const fonteLiberacao = props?.fonteLiberacao

  useEffect(() => {
    canPrintProtocolo({ status, dataTermino, fonteLiberacao }).then(setCanPrint)
  }, [dataTermino, fonteLiberacao])

  return (
    <>
      <ReactToPrint
        trigger={() => (
          <IconButton
            aria-label="Imprimir"
            className="no-print"
            disabled={!canPrint}
          >
            <Print />
          </IconButton>
        )}
        content={() => printRef.current}
      />
      <div hidden>
        <Grid ref={printRef}>
          <SolicitacaoPrint item={props} />
        </Grid>
      </div>
    </>
  )
}

const UltimaFicha = ({ history }) => {
  const classes = useStyles()
  const [ability] = useAbility()
  const location = useLocation()
  const [item, setItem] = useState(null)
  const [fetching, setFetching] = useState(false)

  useEffect(() => {
    const fetchData = async params => {
      setFetching(true)
      const response = await consultaHistoricoRepository.getUltimaFicha(params)
      setItem(response.ok && response.data?.length ? response.data[0] : null)
      setFetching(false)
    }
    const params = new URLSearchParams(location.search)
    fetchData({
      query: {
        cpf: params.get('cpf'),
        placa: params.get('placa'),
        cpfcnpj: params.get('cpfcnpj')
      }
    })
  }, [location.search])

  if (fetching) {
    return (
      <Grid container justifyContent="center">
        <CircularProgress size={24} />
      </Grid>
    )
  }

  if (!item) {
    const emptyText = location.search.length
      ? 'Sem Resultados.'
      : 'Informe pelo menos um filtro de busca.'
    return (
      <Paper className={classes.informacao}>
        <Typography variant="body1" align="center">
          {emptyText}
        </Typography>
      </Paper>
    )
  }

  const canClick = ability.can('read', 'solicitacoesAnalista')

  return (
    <Paper className={classes.informacao}>
      <TableContainer>
        <Table aria-label="Última ficha" size="small" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>Motorista</TableCell>
              <TableCell>Data Criação</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Data Término</TableCell>
              <TableCell>Mercadoria</TableCell>
              <TableCell>Embarcador</TableCell>
              <TableCell>Centro de Custo</TableCell>
              <TableCell>Responsável</TableCell>
              <TableCell>Placa</TableCell>
              <TableCell>Empresa</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              hover={canClick}
              style={canClick ? { cursor: 'pointer' } : undefined}
              onClick={
                canClick
                  ? () => history.push(`/solicitacoes/${item.id}`)
                  : undefined
              }
            >
              <TableCell>{item.id}</TableCell>
              <TableCell>
                {item.motorista ? abbreviate(item.motorista.nome) : '-'}
              </TableCell>
              <TableCell>
                {moment(item.createdAt).format('DD/MM/YYYY HH:mm')}
              </TableCell>
              <TableCell>
                <BadgeStatus
                  status={item.status}
                  fonteLiberacao={item.fonteLiberacao}
                  cenario={item.cenario}
                />
              </TableCell>
              <TableCell>
                {item.dataTermino
                  ? moment(item.dataTermino).format('DD/MM/YYYY HH:mm')
                  : '-'}
              </TableCell>
              <TableCell>
                {item.mercadoria ? item.mercadoria.descricao : '-'}
              </TableCell>
              <TableCell>
                {item.nomeEmbarcador ? abbreviate(item.nomeEmbarcador) : ''}
              </TableCell>
              <TableCell>
                {item.centroCusto ? item.centroCusto.descricao : '-'}
              </TableCell>
              <TableCell>
                {item.responsavel ? item.responsavel.usuario : '-'}
              </TableCell>
              <TableCell>
                {item.veiculos
                  ? item.veiculos.map(v => v.placa).join(' > ')
                  : '-'}
              </TableCell>
              <TableCell align="center">
                {item.empresa ? item.empresa.sigla : '-'}
              </TableCell>
              <TableCell>
                <Box onClick={event => event.stopPropagation()}>
                  <ComponentImpressao props={item} />
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

export default UltimaFicha
